export const SET_ACTIVE_FORM = 'SET_ACTIVE_FORM';
export const FETCH_DATA = 'FETCH_DATA';
export const UPDATE_PORTAL_DATA = 'UPDATE_PORTAL_DATA';
export const UPDATE_USER_EMAIL = 'UPDATE_USER_EMAIL';
export const SET_SESSION_STATUS = 'SET_SESSION_STATUS';
export const SET_NO_DATA_ERROR = 'SET_NO_DATA_ERROR';
export const SET_PORTAL_CODE = 'SET_PORTAL_CODE';
export const SET_PORTAL_SSO_CODE = 'SET_PORTAL_SSO_CODE';
export const SET_PORTAL_USER_DATA = 'SET_PORTAL_USER_DATA';